import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const DividerMeta: ComponentMeta = {
  componentName: "Divider",
  package: "@mijadesign/web",
  title: "分割线",
  description: "用于分隔内容",
  category: ComponentCategory.LAYOUT,
  icon: "MinusOutlined",
  canHaveChildren: false,
  props: [
    {
      name: "type",
      label: "方向",
      type: PropType.ENUM,
      defaultValue: "horizontal",
      options: [
        { label: "水平", value: "horizontal" },
        { label: "垂直", value: "vertical" },
      ],
      group: "基础",
    },
    {
      name: "dashed",
      label: "虚线",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "样式",
    },
    {
      name: "orientation",
      label: "文字位置",
      type: PropType.ENUM,
      options: [
        { label: "左侧", value: "left" },
        { label: "居中", value: "center" },
        { label: "右侧", value: "right" },
      ],
      group: "样式",
    },
  ],
  defaultProps: {
    type: "horizontal",
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Divider",
  },
  snippet: {
    componentName: "Divider",
    package: "@mijadesign/web",
    props: {},
  },
};
